const localization_theme = {

    categories_table: {

        body: {
            editRow: {
                saveTooltip: "Save",
                cancelTooltip: "Cancel",
                deleteText: "Are you sure you want to delete this Category?"
            },
            addTooltip: "Add Category",
            deleteTooltip: "Delete",
            editTooltip: "Edit",

            emptyDataSourceMessage: 'No records to display',
            filterRow: {
                filterTooltip: 'Filter list'
            }
        },

        pagination: {
            labelDisplayedRows: '{from}-{to} of {count}'
        },

        toolbar: {
            nRowsSelected: '{0} row(s) selected'
        },
        header: {
            actions: 'Actions'
        },


    },

};

export { localization_theme as default };